/**
 * ScrollToTop component.
 * @module components/ScrollToTop/ScrollToTop
 *
 * - changed scrollToTop function to use the button as link ancor to #view
 */

import React, { useState, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button, Icon } from 'semantic-ui-react';

const messages = defineMessages({
  scrollToTop: {
    id: 'Scroll to top',
    defaultMessage: 'Torna su',
  },
});

const ScrollToTop = () => {
  const intl = useIntl();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: document.getElementById('view').offsetTop,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <div className="scroll-to-top">
          <Button
            title={intl.formatMessage(messages.scrollToTop)}
            onClick={scrollToTop}
            color="blue"
          >
            <Icon name="arrow up" />
          </Button>
        </div>
      )}
    </>
  );
};

export default ScrollToTop;
